import { featureFlagManagerForInitialization } from '@service/initializationFeatureFlags';
import React, { useEffect } from 'react';
import { useAuth } from 'react-oidc-context';
import { useHistory } from 'react-router-dom';

export default function OidcCallback() {
  const { isAuthenticated } = useAuth();
  const history = useHistory();

  const isKeycloakSsoEnabled =
    featureFlagManagerForInitialization.getIsKeycloakLoginWithSso();

  useEffect(() => {
    // ? : react-oidc-context processes the callback automatically via onSigninCallback
    // ? : We only need to navigate when authentication state flips to true
    if (isAuthenticated && isKeycloakSsoEnabled) {
      try {
        // ? : Clear any logout intent after successful login
        localStorage.removeItem('LOGOUT_INTENT');
      } catch {
        /* empty */
      }
      history.replace('/');
    }
  }, [isAuthenticated, isKeycloakSsoEnabled, history]);

  if (!isKeycloakSsoEnabled) {
    return null;
  }

  return <div>Signing you in…</div>;
}
